export async function audioUrlToFile(audioUrl: string, fileName: string) {
  try {
    // Fetch the audio from the URL
    const response = await fetch(audioUrl);

    // Check if the fetch was successful
    if (!response.ok) {
      throw new Error(
        `Failed to fetch audio: ${response.status} ${response.statusText}`
      );
    }

    // Get the audio data as a blob
    const audioBlob = await response.blob();

    // Create a File object from the blob
    const audioFile = new File([audioBlob], fileName, {
      type: audioBlob.type || "audio/mpeg"
    });

    return audioFile;
  } catch (error) {
    console.error("Error converting audio URL to file:", error);
    throw error;
  }
}
